import React, { FC } from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'
import './index.scss'

import noData from '@img/noData.png'

interface IProps {
  text?: string;
  des?: string;
  type?: 'end' | 'empty';
  btnText?: string;
  img?: string;
  onClick?: () => void;
}
interface IState {
}

const MktEmpty: FC<IProps> = (props) => {
  const { text, type = 'empty', des, btnText, img, onClick } = props
  return (
    <div className='mkt-empty'>
      {type === 'empty' && <img src={img || noData} alt='' />}
      {type === 'end' && <i className='iconfont icon-shalou'></i>}
      <div className='empty-text'>{text || i18n.t('mkt.common.noData')}</div>
      {des && <div className='empty-desc'>{des}</div>}
      {onClick && <div data-cypid='mmgEmptyBack' className='empty-btn' onClick={onClick}>{btnText || i18n.t('common.back')}</div>}
    </div>
  )
}

export default observer(MktEmpty)
